<div class="space-y-12">
  @if (!hideStepHeader()) {
    <div class="max-w-3xl">
      <h2 class="text-3xl font-bold tracking-tight text-neutral-12">Informations clés</h2>
      <p class="mt-2 text-lg text-neutral-11">
        Précisons les éléments essentiels de votre bien immobilier pour commencer.
      </p>
    </div>
  }

  <div class="space-y-8">
    <!-- Surfaces Section -->
    <div class="rounded-3xl border border-neutral-3 bg-neutral-1 p-6 md:p-10">
      <h3 class="mb-6 text-xl font-bold text-neutral-12">Surfaces & Mesurages</h3>
      <etxe-property-surface
        [dto]="model().surface"
        [sellingPriceCents]="sellingPriceCents()"
        (dtoChanged)="onSurfaceChanged($event.dto)"
      ></etxe-property-surface>
    </div>

    <!-- Subtypes Section -->
    <div class="rounded-3xl border border-neutral-3 bg-neutral-1 p-6 md:p-10">
      <h3 class="mb-2 text-xl font-bold text-neutral-12">Type de bien</h3>
      <etxe-property-subtypes
        [dto]="model().subtype"
        [propertyDefinition]="propertyDefinition()"
        (dtoChanged)="onSubtypesChanged($event.dto)"
      ></etxe-property-subtypes>
    </div>

    <!-- Availability Section -->
    <div class="rounded-3xl border border-neutral-3 bg-neutral-1 p-6 md:p-10">
      <h3 class="mb-6 text-xl font-bold text-neutral-12">Disponibilité et état d'occupation</h3>
      <etxe-property-availability
        [dto]="model().availability"
        (dtoChanged)="onAvailabilityChanged($event.dto)"
      ></etxe-property-availability>
    </div>

    <!-- Co-ownership Section -->
    @if (isCoOwnershipApplicable()) {
      <div class="rounded-3xl border border-neutral-3 bg-neutral-1 p-6 md:p-10">
        <h3 class="mb-6 text-xl font-bold text-neutral-12">Régime de copropriété</h3>
        <etxe-property-co-ownership
          [dto]="model().coOwnership"
          (dtoChanged)="onCoOwnershipChanged($event.dto)"
        ></etxe-property-co-ownership>
      </div>
    }
  </div>
</div>
